import { __exportAll } from "../../_virtual/_rolldown/runtime.mjs";
//#region src/store/session/actionTypes.ts
var actionTypes_exports = /* @__PURE__ */ __exportAll({
	BEGIN_LOADING_SESSION_INFO: () => BEGIN_LOADING_SESSION_INFO,
	BEGIN_LOG_IN: () => BEGIN_LOG_IN,
	BEGIN_REGISTER: () => BEGIN_REGISTER,
	BEGIN_REQUEST_HUMAN_STATUS: () => BEGIN_REQUEST_HUMAN_STATUS,
	BEGIN_REQUEST_RESET_PASSWORD: () => BEGIN_REQUEST_RESET_PASSWORD,
	ERROR_LOG_IN: () => ERROR_LOG_IN,
	ERROR_REGISTER: () => ERROR_REGISTER,
	ERROR_REQUEST_HUMAN_STATUS: () => ERROR_REQUEST_HUMAN_STATUS,
	ERROR_REQUEST_RESET_PASSWORD: () => ERROR_REQUEST_RESET_PASSWORD,
	ERROR_SESSION_INFO: () => ERROR_SESSION_INFO,
	FETCH_SESSION_INFO: () => FETCH_SESSION_INFO,
	LOGGED_OUT: () => LOGGED_OUT,
	LOG_IN: () => LOG_IN,
	MAYBE_FETCH_SESSION_INFO: () => MAYBE_FETCH_SESSION_INFO,
	MAYBE_LOG_OUT: () => MAYBE_LOG_OUT,
	RECEIVE_SESSION_INFO: () => RECEIVE_SESSION_INFO,
	REGISTER: () => REGISTER,
	REQUEST_HUMAN_STATUS: () => REQUEST_HUMAN_STATUS,
	REQUEST_RESET_PASSWORD: () => REQUEST_RESET_PASSWORD,
	SUCCESS_LOG_IN: () => SUCCESS_LOG_IN,
	SUCCESS_REGISTER: () => SUCCESS_REGISTER,
	SUCCESS_REQUEST_HUMAN_STATUS: () => SUCCESS_REQUEST_HUMAN_STATUS,
	SUCCESS_REQUEST_RESET_PASSWORD: () => SUCCESS_REQUEST_RESET_PASSWORD,
	TRACK_EVENT: () => TRACK_EVENT
});
var MAYBE_FETCH_SESSION_INFO = "@@od/store/session/maybeFetchSessionInfo";
var FETCH_SESSION_INFO = "@@od/store/session/fetchSessionInfo";
var BEGIN_LOADING_SESSION_INFO = "@@od/store/session/beginLoadingSessionInfo";
var RECEIVE_SESSION_INFO = "@@od/store/session/receiveSessionInfo";
var ERROR_SESSION_INFO = "@@od/store/session/errorSessionInfo";
var BEGIN_LOG_IN = "@@od/store/session/beginLogIn";
var ERROR_LOG_IN = "@@od/store/session/errorLogIn";
var LOG_IN = "@@od/store/session/logIn";
var SUCCESS_LOG_IN = "@@od/store/session/successLogIn";
var BEGIN_REQUEST_HUMAN_STATUS = "@@od/store/session/beginRequestHumanStatus";
var ERROR_REQUEST_HUMAN_STATUS = "@@od/store/session/errorRequestHumanStatus";
var REQUEST_HUMAN_STATUS = "@@od/store/session/requestHumanStatus";
var SUCCESS_REQUEST_HUMAN_STATUS = "@@od/store/session/successRequestHumanStatus";
var BEGIN_REQUEST_RESET_PASSWORD = "@@od/store/session/beginRequestPasswordReset";
var ERROR_REQUEST_RESET_PASSWORD = "@@od/store/session/errorRequestPasswordReset";
var REQUEST_RESET_PASSWORD = "@@od/store/session/requestPasswordReset";
var SUCCESS_REQUEST_RESET_PASSWORD = "@@od/store/session/successRequestPasswordReset";
var BEGIN_REGISTER = "@@od/store/session/beginRegister";
var ERROR_REGISTER = "@@od/store/session/errorRegister";
var REGISTER = "@@od/store/session/register";
var SUCCESS_REGISTER = "@@od/store/session/successRegister";
var MAYBE_LOG_OUT = "@@od/store/session/maybeLogOut";
var LOGGED_OUT = "@@od/store/session/loggedOut";
var TRACK_EVENT = "@@od/store/session/trackEvent";
//#endregion
export { BEGIN_LOADING_SESSION_INFO, BEGIN_LOG_IN, BEGIN_REGISTER, BEGIN_REQUEST_HUMAN_STATUS, BEGIN_REQUEST_RESET_PASSWORD, ERROR_LOG_IN, ERROR_REGISTER, ERROR_REQUEST_HUMAN_STATUS, ERROR_REQUEST_RESET_PASSWORD, ERROR_SESSION_INFO, FETCH_SESSION_INFO, LOGGED_OUT, LOG_IN, MAYBE_FETCH_SESSION_INFO, MAYBE_LOG_OUT, RECEIVE_SESSION_INFO, REGISTER, REQUEST_HUMAN_STATUS, REQUEST_RESET_PASSWORD, SUCCESS_LOG_IN, SUCCESS_REGISTER, SUCCESS_REQUEST_HUMAN_STATUS, SUCCESS_REQUEST_RESET_PASSWORD, TRACK_EVENT, actionTypes_exports };

//# sourceMappingURL=actionTypes.mjs.map